import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from './../../common/Pagination';
import { findPermission } from './../../../utils';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

class Table extends Component {
    static propTypes = {
        elements: PropTypes.array,
        handleSort: PropTypes.func,
        handleUpdateFormValue: PropTypes.func,
        isFetchingElements: PropTypes.bool,
        handleShowForm: PropTypes.func,
        handleShowDelete: PropTypes.func,
        totalPages: PropTypes.number,
        selectedPage: PropTypes.number,
        elementsPerPage: PropTypes.number,
        sortColumn: PropTypes.string,
        sortType: PropTypes.string,
        handleViewProperty: PropTypes.func,
        handleChangeFilter: PropTypes.func,
        user: PropTypes.object,
        filterFields: PropTypes.object
    };

    renderTableHeader(label, name, style, sortable = true) {
        const { handleSort, sortColumn, sortType } = this.props;

        let icon = <i className="fas fa-sort" />;
        if (sortColumn === name) {
            if (sortType === 'asc') {
                icon = <i className="fas fa-sort-up" />;
            } else {
                icon = <i className="fas fa-sort-down" />;
            }
        }

        if (sortable) {
            return <th style={style}><span onClick={handleSort.bind(this, name)}>{label} {icon}</span></th>;
        }

        return <th style={style}>{label}</th>;
    }

    renderData() {
        const { elements, isFetchingElements, handleShowForm, handleShowDelete, user } = this.props;

        if (isFetchingElements) {
            return (
                <tr>
                    <td colSpan="17"><i className="fas fa-circle-notch fa-spin" /> Loading data...</td>
                </tr>
            );
        }

        if (elements.length === 0) {
            return (
                <tr>
                    <td colSpan="17">No Results</td>
                </tr>
            );
        }

        let permission = null;
        if (user) {
            permission = findPermission(user['permissions'], 'Employees');
        }

        let data = [];
        for (let i = 0; i < elements.length; i++) {
            let editAction = null;
            if (permission != null && permission['Edit']) {
                editAction = (
                    <Tooltip title="Edit" position="bottom" arrow size="small" className="action-tooltip">
                        <i className="fas fa-edit" onClick={handleShowForm.bind(this, elements[i].id, null)} />
                    </Tooltip>
                );
            }

            let deleteAction = null;
            if (permission != null && permission['Delete']) {
                deleteAction = (
                    <Tooltip title="Delete" position="bottom" arrow size="small" className="action-tooltip">
                        <i className="fas fa-trash" onClick={handleShowDelete.bind(this, elements[i].id)} />
                    </Tooltip>
                );
            }

            data.push(
                <tr key={i}>
                    <td>{elements[i].id}</td>
                    <td>{elements[i].name}</td>
                    <td>{elements[i].email}</td>
                    <td>{elements[i].department}</td>
                    <td>{elements[i].job_title}</td>
                    <td>{parseInt(elements[i].shift) === 1 ? 'Day' : 'Night'}</td>
                    <td>{parseInt(elements[i].payment_type) === 1 ? 'Salary' : 'Hourly'}</td>
                    <td>
                        <div className="actions">
                            {editAction}
                            {deleteAction}
                        </div>
                    </td>
                </tr>
            );
        }

        return data;
    }

    handleKey(name, event) {
        const { handleChangeFilter } = this.props;
        if (event.key === 'Enter') {
            handleChangeFilter(name, event);
        }
    }

    renderSearchField(name) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <input type="text" name={name} className="search-input" onBlur={handleChangeFilter.bind(this, name)} onKeyPress={this.handleKey.bind(this, name)} />
            </th>
        );
    }

    renderSearchSelect(name, options) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <select type="text" name={name} className="search-input" onChange={handleChangeFilter.bind(this, name)} >
                    {options.map((option, index) => {
                        return (
                            <option key={index} value={option['value']}>{option['label']}</option>
                        );
                    })}
                </select>
            </th>
        );
    }

    render() {
        const { totalPages, selectedPage, totalItems, handleSetActivePage } = this.props;
        return (
            <div id="tables-container" className="production-container">
                <div className="table-container table-hover">
                    <table id="titles-table" className="table table-sm table-hover">
                        <thead>
                            <tr>
                                {this.renderTableHeader('ID', 'id', { width: 80 })}
                                {this.renderTableHeader('Name', 'name')}
                                {this.renderTableHeader('Email', 'email')}
                                {this.renderTableHeader('Department', 'department')}
                                {this.renderTableHeader('Job Title', 'job_title')}
                                {this.renderTableHeader('Shift', 'shift', { width: 80 })}
                                {this.renderTableHeader('Payment Type', 'payment_type', { width: 120 })}
                                <th style={{ width: 80 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {this.renderSearchField('id')}
                                {this.renderSearchField('name')}
                                {this.renderSearchField('email')}
                                {this.renderSearchField('department')}
                                {this.renderSearchField('job_title')}
                                {this.renderSearchSelect('shift', [
                                    { label: '', value: '' },
                                    { label: 'Day', value: '1' },
                                    { label: 'Night', value: '2' }
                                ])}
                                {this.renderSearchSelect('payment_type', [
                                    { label: '', value: '' },
                                    { label: 'Salary', value: '1' },
                                    { label: 'Hourly', value: '2' }
                                ])}
                                <th className="search-th"></th>
                            </tr>
                            {this.renderData()}
                        </tbody>
                    </table>
                    <Pagination.Container
                        totalItems={totalItems}
                        totalPages={totalPages}
                        selectedPage={selectedPage}
                        elementsPerPage={20}
                        handleSetActivePage={handleSetActivePage}
                    />
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

export default Table;
